<script lang="ts" setup>
defineProps({
  isLoading: {
    type: String,
    default: '',
  },
  isNotAvailableToIncrement: {
    type: Boolean,
    default: false,
  },
  countInCart: {
    type: Number,
    default: 0,
  },
  bordered: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['decrement', 'increment']);
</script>

<template>
  <div class="flex items-center">
    <ConfirmationDropdown
      v-if="countInCart === 1"
      cancelBtnText="Нет"
      okBtnText="Да"
      text="Удалить из корзины?"
      @confirm="$emit('decrement')"
    >
      <button
        :class="{ 'in-cart-counter__btn--bordered': bordered }"
        :disabled="Boolean(isLoading)"
        class="in-cart-counter in-cart-counter__btn"
        @click.stop.prevent
      >
        <Transition
          v-if="isLoading === 'decrement'"
          class="w-5"
          name="loader"
        >
          <SvgoSpinner
            class="animate-spin"
            title="Идет загрузка..."
          />
        </Transition>

        <SvgoMinusIcon
          v-else
          :font-controlled="false"
          class="size-4"
          filled
        />
      </button>
    </ConfirmationDropdown>

    <button
      v-else
      :class="{ 'in-cart-counter__btn--bordered': bordered }"
      :disabled="Boolean(isLoading)"
      class="in-cart-counter in-cart-counter__btn"
      @click.stop.prevent="$emit('decrement')"
    >
      <Transition
        v-if="isLoading === 'decrement'"
        class="w-5"
        name="loader"
      >
        <SvgoSpinner
          class="animate-spin"
          title="Идет загрузка..."
        />
      </Transition>

      <SvgoMinusIcon
        v-else
        :font-controlled="false"
        class="size-4"
        filled
      />
    </button>

    <span
      :class="{ 'in-cart-counter__counter': bordered }"
      class="in-cart-counter"
    >
      {{ countInCart }}
    </span>

    <button
      :class="{ 'in-cart-counter__btn--bordered': bordered }"
      :disabled="Boolean(isLoading) || isNotAvailableToIncrement"
      class="in-cart-counter in-cart-counter__btn"
      @click.stop.prevent="$emit('increment')"
    >
      <Transition
        v-if="isLoading === 'increment'"
        class="w-5"
        name="loader"
      >
        <SvgoSpinner
          class="animate-spin"
          title="Идет загрузка..."
        />
      </Transition>

      <SvgoPlusIcon
        v-else
        :font-controlled="false"
        class="size-4"
        filled
      />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.in-cart-counter {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 12px;
  height: 12px;
  font-size: $text-xs;

  @media screen and (width >= 400px) {
    width: 24px;
    height: 24px;
  }

  &__counter {
    width: 24px;
    height: 24px;
  }

  &__btn {
    width: 24px;
    height: 24px;
    transition: color 0.2s;

    &:hover {
      color: $label-violet;
    }

    &:disabled {
      color: $hell-black-40;
    }

    &--bordered {
      border: 1px solid $hell-black-10;
      border-radius: 4px;
      transition: background-color 0.2s;

      &:hover {
        background-color: $hell-black-5;
      }

      &:disabled {
        background-color: $hell-black-10;
        color: $hell-black-40;
      }
    }
  }
}
</style>
